import { TThunkAction } from '../../types/redux';
import { selectCurrentPage } from '../../selectors/filters';
import { selectPageCount } from '../../selectors/pagination';
import { setPageOptions } from './actions';
import { getPageOptions } from '../../utils/pagination';

export const updatePagination =
  (): TThunkAction<void> =>
  (dispatch, getState, { custom }) => {
    const state = getState();

    const currentPage = selectCurrentPage(state);
    const pageCount = selectPageCount(state);

    const pageOptions = getPageOptions(currentPage, pageCount, custom.originalUrl);
    dispatch(setPageOptions(pageOptions));
  };
